import { createSlice } from "@reduxjs/toolkit";
import {
  getActiveCompanies,
  getVerifiedCompanies,
  getCompanyBySlug,
  getCompanyById,
  getCompanyStats,
  getMyCompany,
  getAllCompaniesAdmin,
  addCompany,
  updateCompany,
  updateCompanyContact,
  toggleCompanyActive,
  toggleCompanyVerification,
  deleteCompany,
} from "./thunk";
import { toggleBookmark } from "../4-bookmark/thunk";
import { toggleLike } from "../5-like/thunk";

const initialState = {
  companies: [],
  company: null,
  myCompany: null,
  stats: null,
  loading: false,
  error: null,

  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalCount: 0,
    hasNextPage: false,
    hasPrevPage: false,
  },
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ========================
      // PUBLIC
      // ========================
      .addCase(getActiveCompanies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActiveCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload.data;
        action.payload.responseDetails?.pagination &&
          (state.pagination = action.payload.responseDetails.pagination);
      })
      .addCase(getActiveCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getVerifiedCompanies.fulfilled, (state, action) => {
        state.companies = action.payload.data;
      })

      .addCase(getCompanyBySlug.fulfilled, (state, action) => {
        state.company = action.payload;
      })

      .addCase(getCompanyById.fulfilled, (state, action) => {
        state.company = action.payload;
      })

      .addCase(getCompanyStats.fulfilled, (state, action) => {
        state.stats = action.payload;
      })

      // ========================
      // USER (OWNER)
      // ========================
      .addCase(getMyCompany.fulfilled, (state, action) => {
        state.myCompany = action.payload;
      })

      // ========================
      // ADMIN
      // ========================
      .addCase(getAllCompaniesAdmin.fulfilled, (state, action) => {
        state.companies = action.payload.data;
        action.payload.responseDetails?.pagination &&
          (state.pagination = action.payload.responseDetails.pagination);
      })

      .addCase(addCompany.fulfilled, (state, action) => {
        state.companies.unshift(action.payload);
        state.pagination.totalCount += 1;
      })

      .addCase(updateCompany.fulfilled, (state, action) => {
        state.company = action.payload;
      })

      .addCase(updateCompanyContact.fulfilled, (state, action) => {
        state.companies.unshift(action.payload);
        // state.company = action.payload;
      })

      .addCase(toggleCompanyActive.fulfilled, (state, action) => {
        const company = state.companies.find((c) => c.id === action.payload);
        if (company) company.isActive = !company.isActive;
      })

      .addCase(toggleCompanyVerification.fulfilled, (state, action) => {
        const company = state.companies.find((c) => c.id === action.payload);
        if (company) company.isVerified = !company.isVerified;
      })

      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.companies = state.companies.filter(
          (c) => c.id !== action.payload,
        );
      })
      .addCase(toggleBookmark.fulfilled, (state, action) => {
        const postId = action.meta.arg;

        const updatePosts = (posts) => {
          const post = posts?.find((p) => p.id === postId);
          if (post) {
            post.bookmarked = !post.bookmarked;
          }
        };

        if (state.myCompany?.Posts) {
          // console.log("myCompany");
          // console.log(state.myCompany);
          updatePosts(state.myCompany.Posts);
        }

        if (state.company?.Posts) {
          // console.log("company");
          updatePosts(state.company.Posts);
        }
      })

      // ========================
      // TOGGLE LIKE (LISTEN FROM HOME POSTS)
      // ========================
      .addCase(toggleLike.fulfilled, (state, action) => {
        const postId = action.meta.arg;
        const { liked } = action.payload;

        const updatePosts = (posts) => {
          const post = posts?.find((p) => p.id === postId);
          if (post) {
            post.liked = liked;
            post.likeCount += liked ? 1 : -1;
          }
        };

        if (state.myCompany?.Posts) {
          updatePosts(state.myCompany.Posts);
        }

        if (state.company?.Posts) {
          updatePosts(state.company.Posts);
        }
      });
  },
});

export default companySlice.reducer;
